var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-print-block",attrs:{"id":"print"}},[_c('page-1'),_c('page-2'),_c('page-3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }